import React from 'react'
import {
	EnabledServices,
	SiteConfiguration,
} from '@matech/thebigpos-sdk'
import {
	FeatureProps,
	FeaturesFormFieldValues,
} from '@/components/admin/Features/types'
import {
	FEATURE_TITLE_BLACKLIST,
	FEATURES_MAP,
	FeatureValue,
} from './Features/constants'
import { UseSiteConfigurationByEntityTypeProps } from '../../hooks/useSiteConfigurationByEntity'
import FeaturesForm from './Features/FeaturesForm'
import {
	getSiteConfigurationFromFeaturesForm,
	sortFeatures,
} from './Features/helpers'

export type FeaturesProps = {
	entityType: UseSiteConfigurationByEntityTypeProps['entityType']
	siteConfiguration: SiteConfiguration
	inheritedSiteConfiguration?: SiteConfiguration
	onChange?: (data: SiteConfiguration) => void
}

const Features = ({
	entityType,
	siteConfiguration,
	inheritedSiteConfiguration,
	onChange,
}: FeaturesProps) => {
	const { enabledServices } = siteConfiguration

	const features: FeatureProps[] = Object.entries(enabledServices)
		.filter(
			([key]) =>
				FEATURES_MAP[key] !== undefined &&
				!FEATURE_TITLE_BLACKLIST.includes(key) &&
				!FEATURES_MAP[key].hideForSiteTypes?.includes(entityType)
		)
		.map(([key, value]: [string, FeatureValue]) => {
			return {
				...FEATURES_MAP[key],
				value,
				dependentFields: FEATURES_MAP[key].dependentFields?.map(
					(field) => ({
						...field,
						value:
							enabledServices[field.field as keyof EnabledServices] ??
							siteConfiguration[
								field.field as keyof SiteConfiguration
							] ??
							null,
					})
				),
			}
		})
		.sort(sortFeatures)

	const handleChange = (data: FeaturesFormFieldValues) => {
		const { newSiteConfiguration, newEnabledServices } =
			getSiteConfigurationFromFeaturesForm(data, siteConfiguration)

		const updatedSiteConfiguration = {
			...siteConfiguration,
			...newSiteConfiguration,
			enabledServices: {
				...enabledServices,
				...newEnabledServices,
			},
		}
		onChange?.(updatedSiteConfiguration)
	}

	return (
		<FeaturesForm
			heading="Global System Features"
			features={features}
			entityType={entityType}
			inheritedSiteConfiguration={inheritedSiteConfiguration}
			onChange={handleChange}
		/>
	)
}

export default Features
